import AssetsLibrary from './AssetsLibrary';

export default AssetsLibrary;
